import styled from 'styled-components'
import {SlotStatusType} from '@common/models'

import {Container} from '~/components/general/container/Container'
import {StyledContainer} from '~/components/general/container/Container.styled'
import {theme} from '~/styles/theme'

const GRID_GAP = 8

const getStatusBorderColor = (status: SlotStatusType): string => {
  switch (status) {
    case SlotStatusType.AVAILABLE:
      return theme.colors.indicator.border.green
    case SlotStatusType.SCHEDULED:
      return theme.colors.indicator.border.orange
    case SlotStatusType.FULFILLED:
      return theme.colors.primary.blue50
    case SlotStatusType.NO_SHOW:
      return theme.colors.indicator.border.red
    case SlotStatusType.BLOCKED:
      return theme.colors.grey.grey90
    default:
      return theme.colors.indicator.border.red
  }
}

export const PatientsWeekTimeline = styled(Container)`
  width: 100%;
  background: ${theme.colors.grey.grey20};
  border-radius: 8px;
  border: 1px solid ${theme.colors.grey.grey100};
  padding: 8px;
`

export const WeekHeaderRow = styled(Container)`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: ${GRID_GAP}px;
  position: sticky;
  top: 0;
  z-index: 2;
  background: ${theme.colors.grey.grey20};
  padding-bottom: ${GRID_GAP}px;
`

export const DayHeader = styled(Container)`
  background: ${theme.colors.grey.grey40};
  border: 1px dashed ${theme.colors.grey.grey100};
  border-radius: 6px;
  padding: 4px 6px;
`

export const ServicesStack = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: ${GRID_GAP}px;
`

export const ServiceSection = styled(Container)`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: auto;
  gap: ${GRID_GAP}px;
`

export const ServiceHeaderFull = styled(Container)`
  grid-column: 1 / -1;
  background: ${theme.colors.white};
  border: 1px solid ${theme.colors.grey.grey100};
  border-radius: 6px;
  padding: 6px 8px;
  position: relative;
  z-index: 1;
`

export const ServiceNameButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  text-align: left;
  color: ${theme.colors.primary.main};
  text-decoration: underline;

  &:hover {
    opacity: 0.85;
  }
`

export const SlotItem = styled(Container)<{
  $status: SlotStatusType
  title?: string
}>`
  position: relative;
  width: 100%;
  background: ${theme.colors.white};
  border: 2px solid ${({$status}) => getStatusBorderColor($status)};
  border-radius: 6px;
  padding: 6px 8px;
`

export const SlotClickTarget = styled(StyledContainer)`
  cursor: pointer;
  width: 100%;
`

export const PageContainer = styled(Container)`
  height: 100%;
`

export const GridWrapper = styled(Container)`
  flex: 1;
  min-height: 0;
  overflow: auto;
`

export const DayColumn = styled(Container)<{
  $col: number
}>`
  grid-column: ${({$col}) => $col};
  min-width: 0;
`
